
import { CSSProperties } from 'vue';
import { Component, mixins } from 'nuxt-property-decorator';
import { rem } from '../../../helpers';
import { HeaderSectionImageType } from '../../../services';
import WebsiteHeaderMixin from './WebsiteHeaderMixin';

const CARD_HEIGHTS = {
  base: 70,
  withButtonsSingle: 94,
  withButtonsMultiple: 106,
};

@Component
export default class WebsiteHeaderLifted extends mixins(WebsiteHeaderMixin) {
  get rootClassNames(): Record<string, boolean> {
    return {
      '-full-width': this.headerSection.imageType === HeaderSectionImageType.FullWidth,
      '-with-buttons': this.hasButtons,
    };
  }

  get rootStyles(): CSSProperties {
    return { '--card-height': `${rem(this.cardHeight)}` };
  }

  get hasMultipleMetaInfos(): boolean {
    return this.headerMetaInfos.length > 1;
  }

  get cardHeight(): number {
    return this.hasButtons
      ? this.hasMultipleMetaInfos
        ? CARD_HEIGHTS.withButtonsMultiple
        : CARD_HEIGHTS.withButtonsSingle
      : CARD_HEIGHTS.base;
  }
}
